import { render, staticRenderFns } from "./buy_recognition_component.vue?vue&type=template&id=41af33d1&scoped=true"
import script from "./buy_recognition_component.vue?vue&type=script&lang=js"
export * from "./buy_recognition_component.vue?vue&type=script&lang=js"
import style0 from "./buy_recognition_component.vue?vue&type=style&index=0&id=41af33d1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af33d1",
  null
  
)

export default component.exports